


























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
const RegisterHfInputWithoutCategory = () =>
  import("@/components/forms/RegisterHfInputWithoutCategory.vue");

@Component({
  components: {
    RegisterHfInputWithoutCategory
  }
})
export default class RegisterHfEditModal extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() data: any = null;

  get show() {
    return this.value;
  }
  set show(value) {
    this.$emit("input", value);
  }

  get dataReg() {
    return this.data;
  }

  mounted() {
    console.log(this.data);
  }

  close() {
    this.show = false;
  }

  // save() {
  //   console.log("this data", this.data);
  //   console.log("save!");
  // }

  successUpdateEvent() {
    this.$emit("successUpdate");
    this.show = false;
  }
}
